// src/components/SideNavBar.js
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LuLayoutDashboard, LuArrowRightLeft, LuSlidersHorizontal, LuUserRound, LuChartArea } from "react-icons/lu";

const navLinks = [
    { icon: LuLayoutDashboard, text: 'Dashboard', path: '/' },
    { icon: LuArrowRightLeft, text: 'Trades', path: '/trades' },
    { icon: LuSlidersHorizontal, text: 'Brokers', path: '/brokers' },
    { icon: LuChartArea, text: 'Analytics', path: '/analytics' },
    { icon: LuUserRound, text: 'Settings', path: '/settings' },
];

const SideNavBar = () => {
    const location = useLocation();

    return (
        <div className="w-64 bg-white border-r border-slate-200 flex flex-col">
            <div className="p-4 border-b border-slate-200 flex items-center space-x-2">
                <LuChartArea className="text-blue-600" size={32} />
                <h1 className="text-xl font-bold text-slate-800">TradeLink</h1>
            </div>
            <nav className="flex-grow p-4 space-y-2">
                {navLinks.map((link) => (
                    <NavLink
                        key={link.path}
                        to={link.path}
                        className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-colors ${
                            location.pathname === link.path
                                ? 'bg-blue-600 text-white shadow-md'
                                : 'text-slate-600 hover:bg-slate-100'
                        }`}
                    >
                        <link.icon size={22} />
                        <span className="font-semibold">{link.text}</span>
                    </NavLink>
                ))}
            </nav>
        </div>
    );
};

export default SideNavBar;